import _ from 'lodash'
import { getEquationFromColumn } from 'scoreboard/datasets/edit/field-equation-formatter'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO, DATE, TIME, DATE_TIME, CALENDAR_PERIOD } = DataType
const INVALID_PK_DATA_TYPES = [ DATE, TIME, DATE_TIME, YES_NO, CALENDAR_PERIOD ]

const filterManuallyAddedFieldId = (dataset) => {
	const fields = dataset.get('fields')
	if (!fields) return []

	return _.filter(fields, field =>
		!_.isNil(field.id) && !dataset.isManuallyAddedFieldId(field.id))
}

/**
 * #42525 In a list of dataset fields, filters out fields that are invalid for
 * use as a primary key
 */
export default {
	INVALID_PK_DATA_TYPES,
	/**
	 * @param dataset {Dataset}
	 * @return {DatasetField[]}
	 */
	getValidPrimaryKeyDatasetFields(dataset) {
		const fields = dataset.get('fields')
		if (_.isNil(fields)) return []

		// all field types are valid for datasets with no source
		if (dataset.hasNoDataSource()) return filterManuallyAddedFieldId(dataset)

		return filterFields(dataset.get('fields'))
	},
	/**
	 * @param fields {{fieldType: string, dataType: string}[]}
	 */
	getValidPrimaryKeyAutomaticFields(fields) {
		if (_.isNil(fields)) return []

		return filterFields(fields)
	},

	/**
	 *
	 * @param dataset {Dataset}
	 * @param automaticFields {{fieldType: string, dataType: string}[]}
	 */
	getValidPrimaryKeyAutomaticAndDatasetFields(dataset, automaticFields) {
		const filteredFields = filterManuallyAddedFieldId(dataset)
		const datasetFieldsByEquation = _.keyBy(filteredFields, field =>
			(_.get(field, 'equation') || '').toLowerCase())
		return _.filter(automaticFields, automaticField => {
			const columnName = (_.get(automaticField, 'label') || '').toLowerCase()
			const columnEquation = getEquationFromColumn(columnName)
			const foundDatasetField = datasetFieldsByEquation[columnEquation]

			let dataTypeToUse
			// if there's a DatasetField for this column, and it's a BASIC field, use the
			// DatasetField's dataType
			if (foundDatasetField) {
				if (foundDatasetField.invalidForPrimaryKey) return false

				dataTypeToUse = foundDatasetField.dataType
			} else {
				dataTypeToUse = automaticField.dataType
			}

			return !INVALID_PK_DATA_TYPES.includes(dataTypeToUse)
		})
	}
}

/**
 * @param fields {{fieldType: string, dataType: string}[]}
 */
function filterFields(fields) {
	if (!fields) return []
	return _.filter(fields, f => {
		return (!f.fieldType || f.fieldType === 'basic') &&
			!isInvalidForPrimaryKey(f) &&
			!INVALID_PK_DATA_TYPES.includes(f.dataType)
	})
}

function isInvalidForPrimaryKey(field) {
	if (_.isNil(field.invalidForPrimaryKey)) return false

	return field.invalidForPrimaryKey
}
